export default __webpack_public_path__ + "static/particles-81dce1916f70450315c03d949664a1db.jpg";